module.exports = __webpack_public_path__ + "img/axis2.127d0d77.jpg";